module.exports = __webpack_public_path__ + "img/undraw_Social_ideas_re_j5v4.ae0e2b08.svg";